import React, { useState, useEffect, useMemo } from 'react'
import Select from 'react-select';
import Tab from './Tab';
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

import ResponceJSON_ONE from './ResponceJSON_ONE';
import RequestJSON_ONE from './RequestJSON_ONE';

import ResponceJSON_TWO from './ResponceJSON_TWO';
import RequestJSON_TWO from './RequestJSON_TWO';
import RequestJSONflowone from "../RequestJSONflowone";
import ResponseJSONflowone from "../ResponseJSONflowone";
function SettlementMISAPIDropDown() {
    const [OptionData, SetOptionData] = useState([])
    const [selectedOption, SetselectedOption] = useState([])
    useEffect(() => {
        const options = [
            { value: '1', label: 'application/json' },
            { value: '2', label: 'request' }
        ];
        SetOptionData(options)
        SetselectedOption({ value: '1', label: 'application/json' })
    }, []);

    const onChangeSelected = (data) => {
        SetselectedOption(data)
    }

    const MemoFun = useMemo(() => {
        if (selectedOption['value'] == 1) {
            return (
                <>
                    <RequestJSON_ONE selectedOptionData={selectedOption} />
                    <ResponceJSON_ONE />
                </>)
        } else {
            return (<>
                <RequestJSON_TWO selectedOptionData={selectedOption} />
                <ResponceJSON_TWO />
            </>)
        }
    }, [selectedOption])


    const [ShowHideAccordionOne, SetShowHideAccordionOne] = useState(false);
    const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
    const onClickAccordianShowHideOne = () => {
        SetShowHideAccordionOne(!ShowHideAccordionOne)
    }
    const onClickAccordianShowHideTwo = () => {
        SetShowHideAccordionTwo(!ShowHideAccordionTwo)
    }
    const [TabCheck, SetTabCheck] = useState(false)
    const [TabCheck1, SetTabCheck1] = useState(false)
    const [TabCheck2, SetTabCheck2] = useState(false)
    const onClickCangeTab = () => {
        SetTabCheck(!TabCheck);
    }
    const onClickCangeTab1 = () => {
        SetTabCheck1(!TabCheck1);
    }
    const onClickCangeTab2 = () => {
        SetTabCheck2(!TabCheck2);
    }

    return (
        <>
            <div class="row">
                <div class="col-md-8 mt-60">
                    <h2 id="transaction-mis-details-sec">Transaction MIS/ Details Summary</h2>
                    <p>
                        This document consist of Transactional APIs which can be implemented by the merchant to get the status of the transactions done by their customer.
                    </p>


                    <div className="mt-40">
<p><b>UAT URL :</b> <span class="col-red">https://pguat.safexpay.com/agmerchant/sdk/transactionMis/userId/{'UserID'}</span></p>
      <p><b>Production URL : </b><span class="col-red">:https://portal.safexpay.com/sdk_transactionMis_userId/{'User ID'}</span></p>
</div>

                    <img class="img-fluid mt-40" src="assets/images/pg-images/merchant-dashboard.PNG" /><br /><br />
                    <img class="img-fluid" src="assets/images/pg-images/merchant-dashboard-report.PNG" />
                    <h6><u>AUTHORIZATIONS:</u></h6>
                    <h6 className="mt-10">HEADER PARAMETERS</h6>
                    <hr class="hr-col">
                    </hr>
                    <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                            <tr>
                                <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Content-Type">
                                    <span class="sc-iemWCZ fhDkLh"></span><span>Content-Type</span>
                                    <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                        <div>
                                            <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>application/json</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="userId">
                                    <span class="sc-iemWCZ fhDkLh"></span><span>userId</span>
                                    <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                        <div>
                                            <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>This contains encrypted userId with AES encryption</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="last undefined">
                                <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sessionKey">
                                    <span class="sc-iemWCZ fhDkLh"></span><span>sessionKey</span>
                                    <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                        <div>
                                            <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>This contains will get in response after login.</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {/* <h6>REQUEST BODY SCHEMA:  application-json</h6> */}
                    <div style={{ display: "flex" }}>
                        <h2>REQUEST BODY SCHEMA: </h2>
                        <Select
                            value={selectedOption}
                            onChange={onChangeSelected}
                            options={OptionData}
                        />
                    </div>
                    <hr class="hr-col">
                    </hr>
                    <div>
                        {selectedOption['value'] == 1 ?
                            <>
                                <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                        <tr>
                                            <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fromDate"><span class="sc-iemWCZ fhDkLh"></span><span>fromDate</span></td>
                                            <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                    <div>
                                                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                            <p>Transactions beginning from date.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="toDate"><span class="sc-iemWCZ fhDkLh"></span><span>toDate</span></td>
                                            <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                    <div>
                                                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                            <p>Transactions till date</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                                            <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                    <div>
                                                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                            <p>Pay mode= Credit, Debit or Netbanking, upi, wallets</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                                            <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span></div>
                                                    <div>
                                                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                            <p>Status like success,fail, pending, refund, all.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amountFrom"><span class="sc-iemWCZ fhDkLh"></span><span>amountFrom</span></td>
                                            <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                    <div>
                                                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                            <p>Transactions beginning from amount</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amountTo"><span class="sc-iemWCZ fhDkLh"></span><span>amountTo</span></td>
                                            <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                    <div>
                                                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                            <p>Transactions till amount</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="limitFrom"><span class="sc-iemWCZ fhDkLh"></span><span>limitFrom</span></td>
                                            <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                    <div>
                                                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                            <p>No. of transactions can be used for pagination.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="last undefined">
                                            <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="limitTo"><span class="sc-iemWCZ fhDkLh"></span><span>limitTo</span></td>
                                            <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                    <div>
                                                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                            <p>No. of transactions can be used for pagination.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                            :
                            <>
                                <h1>Schema not provided</h1>
                            </>}
                    </div>

                    <h5 className="mt-30">Responses</h5>
                    <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
                        <div class="card">
                            <div class="card-header" id="heading1">
                                <h5 class="mb-0">
                                    <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                                        <b>200</b> A refund response json object {TabCheck1 ?
                                            <FaAngleUp />
                                            :
                                            <FaAngleDown />
                                        }
                                    </div>
                                </h5>
                            </div>
                            {
                                TabCheck1 &&
                                <div>
                                    <div class="card-body">
                                        <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
                                        <hr class="hr-col">
                                        </hr>
                                        <table class="sc-hHEiqL iZJLLY">
                                            <tbody>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transactionId"><span class="sc-iemWCZ fhDkLh"></span><span>transactionId</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div>
                                                                <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agRef">
                                                        <span class="sc-iemWCZ fhDkLh"></span><span>agRef</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meId">
                                                        <span class="sc-iemWCZ fhDkLh"></span><span>meId</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchantName"><span class="sc-iemWCZ fhDkLh"></span><span>merchantName</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="state"><span class="sc-iemWCZ fhDkLh"></span><span>state</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="aggregatorName"><span class="sc-iemWCZ fhDkLh"></span><span>aggregatorName</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="orderNo"><span class="sc-iemWCZ fhDkLh"></span><span>orderNo</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="countryCode"><span class="sc-iemWCZ fhDkLh"></span><span>countryCode</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="currencyCode"><span class="sc-iemWCZ fhDkLh"></span><span>currencyCode</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fee"><span class="sc-iemWCZ fhDkLh"></span><span>fee</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agfee"><span class="sc-iemWCZ fhDkLh"></span><span>agfee</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgfee">
                                                        <span class="sc-iemWCZ fhDkLh"></span><span>pgfee</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meServiceTax">
                                                        <span class="sc-iemWCZ fhDkLh"></span><span>meServiceTax</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meOtherTax"><span class="sc-iemWCZ fhDkLh"></span><span>meOtherTax</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meOtherTax1"><span class="sc-iemWCZ fhDkLh"></span><span>meOtherTax1</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meOtherTax2"><span class="sc-iemWCZ fhDkLh"></span><span>meOtherTax2</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz">
                                                            </span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meNetAmount"><span class="sc-iemWCZ fhDkLh"></span><span>meNetAmount</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                                                <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agServiceTax"><span class="sc-iemWCZ fhDkLh"></span><span>agServiceTax</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agOtherTax1"><span class="sc-iemWCZ fhDkLh"></span><span>agOtherTax1</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agOtherTax2"><span class="sc-iemWCZ fhDkLh"></span><span>agOtherTax2</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agNetAmount">
                                                        <span class="sc-iemWCZ fhDkLh"></span><span>agNetAmount</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgServiceTax"><span class="sc-iemWCZ fhDkLh"></span><span>pgServiceTax</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgOtherTax1"><span class="sc-iemWCZ fhDkLh"></span><span>pgOtherTax1</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgOtherTax2"><span class="sc-iemWCZ fhDkLh"></span><span>pgOtherTax2</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div>
                                                                <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgNetAmount"><span class="sc-iemWCZ fhDkLh"></span><span>pgNetAmount</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meIgst"><span class="sc-iemWCZ fhDkLh"></span><span>meIgst</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meCgst"><span class="sc-iemWCZ fhDkLh"></span><span>meCgst</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meSgst"><span class="sc-iemWCZ fhDkLh"></span><span>meSgst</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz">
                                                            </span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agIgst"><span class="sc-iemWCZ fhDkLh"></span><span>agIgst</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agCgst"><span class="sc-iemWCZ fhDkLh"></span><span>agCgst</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agSgst"><span class="sc-iemWCZ fhDkLh"></span><span>agSgst</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div>
                                                                <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgIgst"><span class="sc-iemWCZ fhDkLh"></span><span>pgIgst</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgCgst"><span class="sc-iemWCZ fhDkLh"></span><span>pgCgst</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgSgst">
                                                        <span class="sc-iemWCZ fhDkLh"></span><span>pgSgst</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgName"><span class="sc-iemWCZ fhDkLh"></span><span>pgName</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymodeId"><span class="sc-iemWCZ fhDkLh"></span><span>paymodeId</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymodeName"><span class="sc-iemWCZ fhDkLh"></span><span>paymodeName</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transactionDate"><span class="sc-iemWCZ fhDkLh"></span>
                                                        <span>transactionDate</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txnAmount"><span class="sc-iemWCZ fhDkLh"></span><span>txnAmount</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="surchargeAmount">
                                                        <span class="sc-iemWCZ fhDkLh"></span><span>surchargeAmount</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txnType">
                                                        <span class="sc-iemWCZ fhDkLh"></span><span>txnType</span>
                                                    </td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="channel"><span class="sc-iemWCZ fhDkLh"></span><span>channel</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ipAddress"><span class="sc-iemWCZ fhDkLh"></span><span>ipAddress</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="serverName"><span class="sc-iemWCZ fhDkLh"></span><span>serverName</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="schemeId"><span class="sc-iemWCZ fhDkLh"></span><span>schemeId</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="custName"><span class="sc-iemWCZ fhDkLh"></span><span>custName</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="emailId"><span class="sc-iemWCZ fhDkLh"></span><span>emailId</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                                                <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="mobileNo"><span class="sc-iemWCZ fhDkLh"></span><span>mobileNo</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="uniqueId"><span class="sc-iemWCZ fhDkLh"></span><span>uniqueId</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div>
                                                                <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="isLoggedIn"><span class="sc-iemWCZ fhDkLh"></span><span>isLoggedIn</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transactionRequestDate"><span class="sc-iemWCZ fhDkLh"></span><span>transactionRequestDate</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz">
                                                            </span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                                            </div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgRef"><span class="sc-iemWCZ fhDkLh"></span><span>pgRef</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txnStatus"><span class="sc-iemWCZ fhDkLh"></span><span>txnStatus</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="subStatus"><span class="sc-iemWCZ fhDkLh"></span><span>subStatus</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="subStatusDescription"><span class="sc-iemWCZ fhDkLh"></span><span>subStatusDescription</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="last undefined">
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transactionStatusDate"><span class="sc-iemWCZ fhDkLh"></span><span>transactionStatusDate</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="mb-0"> <span>400 Bad request</span> </h5>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="mb-0"> <span>404 Not found</span> </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 extreme-rt-div">
                    <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
                        <div class="card">
                            <div class="card-header" id="heading1">
                                <h5 class="mb-0">
                                    <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab1}>
                                        <button> POST </button>  /sdk/transactionMis/ userId/Pooja492{TabCheck1 ?
                                            <FaAngleUp />
                                            :
                                            <FaAngleDown />
                                        }
                                    </div>
                                </h5>
                            </div>
                            {
                                TabCheck1 &&
                                <div>
                                    <br />
                                    <div class="card-body">
                                        <p class="mb-0">Production server (uses live data)</p>
                                        <div class="api-div-bor">
                                            <span>https://www.avantgardepayments.com</span><span
                                                class="col-org">/agmerchant/sdk/transactionMis/userId/Pooja492</span>
                                        </div>
                                        <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                                        <div class="api-div-bor">
                                            <span>https://pguat.safexpay.com</span><span
                                                class="col-org">/agmerchant/sdk/transactionMis/userId/Pooja492</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {MemoFun}
                </div>
            </div>
        </>
    )
}

export default SettlementMISAPIDropDown